import styled, { css } from "styled-components";
import Spring from "../../components/Spring";
import { IActiveStyleProp, IDashedLineStyleProps, IInfoBoxStyleProps } from "./interfaces";

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
`;

export const ListIcon = styled.div<IActiveStyleProp>`
    padding: 3px;
    background-color: ${p => p.theme.c.light};
    border-radius: 34px;
    border: 3px solid ${p => p.theme.c.pale};
    cursor: pointer;
    position: relative;
    [class^="i-"] {
        display: block;
        font-size: 50px;
        color: ${p => p.theme.c.pale};
        ${p =>
            p.theme.xs(css`
                font-size: 32px;
            `)}
    }
    ${p =>
        p.$isActive &&
        css`
            background-color: ${p => p.theme.c.info};
            border-color: ${p => p.theme.c.info};
            [class^="i-"] {
                color: ${p => p.theme.c.whiteOnActive};
            }
        `}
`;

export const Gap = styled.div`
    flex: 1;
    height: 4px;
    background-color: ${p => p.theme.c.pale};
`;

export const ListRow = styled.div`
    display: flex;
    align-items: center;
    margin: 0;
    padding: 20px 150px 200px;
    ${p =>
        p.theme.md.only(css`
            padding: 20px 50px 200px;
        `)}
    ${p =>
        p.theme.sm.only(css`
            padding: 20px 32px 240px;
        `)}
    ${p =>
        p.theme.xs(css`
            padding: 20px 0 240px;
        `)}
`;

export const FloatingIcon = styled.div`
    position: absolute;
    left: 80px;
    top: 80px;

    ${p =>
        p.theme.sm.only(css`
            left: 68px;
        `)}
    ${p =>
        p.theme.xs(css`
            left: calc(100vw / 14);
        `)}
    svg, [class^="i-"] {
        display: block;
        font-size: 42px;
        color: ${p => p.theme.c.pale};
    }
`;

export const FloatingPlay = styled(FloatingIcon)``;
export const FloatingMeta = styled(FloatingIcon)`
    top: 230px;
`;

export const FloatingSharePlay = styled(FloatingIcon)``;

export const FloatingRefresh = styled(FloatingIcon)`
    top: 130px;
`;

export const FloatingShare = styled(FloatingIcon)`
    top: 180px;
`;

export const FloatingPublish = styled(FloatingIcon)`
    top: 230px;
`;

export const DashedLine = styled.div<IDashedLineStyleProps>`
    position: absolute;
    top: 20px;
    left: 40px;
    background-image: linear-gradient(to right, ${p => p.theme.c.pale} 47%, rgba(255,255,255,0) 0%);
    background-position: bottom;
    background-size: 14px 1px;
    background-repeat: repeat-x;
    width: 110px;
    ${p =>
        p.theme.sm.only(css`
            width: 80px;
        `)}
    ${p =>
        p.theme.xs(css`
            width: calc((100vw - 296px) / 5 + 4px);
        `)}
    ${p =>
        p.long &&
        css`
            width: 330px;
            ${p =>
                p.theme.sm.only(css`
                    width: 400px;
                `)}
            ${p =>
                p.theme.xs(css`
                    width: 700px;
                `)}
        `}

    ${p =>
        p.short &&
        css`
            width: 65px;
            ${p =>
                p.theme.sm.only(css`
                    width: 40px;
                `)}
            ${p =>
                p.theme.xs(css`
                    width: calc((100vw - 296px) / 10 + 4px);
                `)}
        `}

    ${p =>
        p.stopped &&
        css`
            width: 226px;
            ${p =>
                p.theme.sm.only(css`
                    width: 160px;
                `)}
            ${p =>
                p.theme.xs(css`
                    width: calc((3 * 100vw - 144px) / 10 - 24px);
                `)}
        `}
    height: 1px;
`;

export const InfoBox = styled.div<IInfoBoxStyleProps>`
    position: absolute;

    top: 108px;
    left: 688px;
    right: 32px;
    height: 180px;

    color: ${p => p.theme.c.dark};
    * {
        opacity: ${p => p.opacity};
        transition: opacity ${p => p.transition}ms;
    }
    ${p =>
        p.theme.md.only(css`
            left: 480px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            position: static;
            margin: 0 32px;
            padding-top: 2px;
        `)}
    ${p =>
        p.theme.xs(css`
            position: static;
            margin: 0;
            padding-top: 2px;
            height: auto;
            padding-bottom: 6px;
        `)}

    box-shadow: 0 0 10px 1px ${p => p.theme.c.snowOnActive};
    border-radius: 4px;
    background-color: ${p => p.theme.c.light};
    padding: 0 16px;
`;

export const LineEnding = styled.div`
    height: 12px;
    border-right: solid 2px ${p => p.theme.c.pale};
    margin-top: -5px;
`;

export const Plan = styled.div`
    margin: 42px 32px;
    padding: 24px;
    ${p =>
        p.theme.xs(css`
            position: static;
            margin: 20px 0;
            padding-top: 2px;
        `)}
    border-radius: 6px;
    box-shadow: 0 0 10px 1px ${p => p.theme.c.snow};
    background-color: ${p => p.theme.c.snow};
`;
export const Process = styled.div`
    position: relative;
`;
